<template>
  <div v-if="!this.datas[0].x.length > 0">
    <h3> No {{ title }} data available in the database </h3>
  </div>
  <div v-else>
    <Plotly :data='data' :layout='layout' :display-mode-bar='false'></Plotly>
  </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
export default {
  components: {
    Plotly
  },
  props: {
    title: String,
    datas: Array,
    layouts: Object
  },
  data () {
    return {
      data: this.datas,
      layout: {
        title: this.title
      }
    }
  },
  mounted () {
  }
}

</script>



// WEBPACK FOOTER //
// src/components/PlotlyComponent.vue